const getters = {
    hotdesk(state) {
        const hotdesk = state.hotdesks[state.hotdeskNumber] || {
            number: state.hotdeskNumber,
            state: "UNKNOWN",
            sip_account: null,
            cid_number: "",
            cid_name: "",
            is_forward_active: false,
            forward_destination: "",
        };
        return hotdesk;
    },

    hotdeskState(state, getters) {
        return getters.hotdesk.state;
    },

    isHotdeskUnavailable(state, getters) {
        return (
            getters.hotdeskState === "UNAVAILABLE" ||
            getters.hotdeskState === "UNKNOWN"
        );
    },

    isHotdeskActive(state, getters) {
        return (
            getters.hotdeskState === "NOT_INUSE" ||
            getters.hotdeskState === "RINGING" ||
            getters.hotdeskState === "INUSE"
        );
    },
};

export default getters;
